import axios, { AxiosResponse } from "axios";
import TitleValue from "../../models/dtos/base/TitleValue";
import BaseService from "../base/BaseService";

export default class StudentFieldService extends BaseService {
    getTitleValues(): Promise<TitleValue<number>[]> {
        return axios.get( '/StudentField/TitleValues')
            .then(function (response: AxiosResponse<TitleValue<number>[], any>) {
                return response.data;
            });
    }
}